// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e43b2f4d","428":"3eb584c7","455":"95ba6641","759":"b9784b4f","958":"c117676c"}[chunkId] + ".chunk.js";
};